// extracted by mini-css-extract-plugin
export default {"interactiveContainer":"styles_interactiveContainer__eDkFt","inactive":"styles_inactive__vj+BN","textContainer":"styles_textContainer__1fK11"};